import { faRectangleVerticalHistory } from "@fortawesome/pro-regular-svg-icons/faRectangleVerticalHistory";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Box, IconButton, Stack, Typography, useTheme } from "@mui/material";
import { MprcClickable, MprcContainer, MprcFormBarHeader, MprcInfiniteLoading } from 'components';
import { ButtonBack } from 'components/buttons';
import { TrainingType } from "generated/CoreApi_v1";
import { useWindowSize } from "hooks/useWindowSize";
import React, { useMemo } from 'react';
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router";
import { LmsPaths } from "routes/LmsRouter";
import { useGobackOrLms } from "views/common/hooks/useGobackOrHome";
import { useEnrollmentViewContext } from "views/lms/student/EnrollmentView";

///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

export const ENROLLMENT_VIEW_BAR_ID = "enrollmentViewBar";
interface IProps {
    loading: boolean;
    onClickRightPanel?: () => void;
}

///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

export const EnrollmentViewBar: React.FC<IProps> = ({ loading, onClickRightPanel }) => {
    const goBackOrHome = useGobackOrLms();
    const theme = useTheme();
    const { width } = useWindowSize({ wait: 50 });

    const { t } = useTranslation();
    const navigate = useNavigate();
    const { enrollment } = useEnrollmentViewContext();

    const goBack = () => {
        goBackOrHome();
    };

    ///
    const headerActions = useMemo(() => {
        var headerItems: React.ReactNode[] = [<ButtonBack rounded size="large" variant="text" onClick={goBack} />];

        if (width < theme.breakpoints.values["md"]) {
            headerItems.push(
                [
                    <IconButton key="back" onClick={onClickRightPanel}>
                        <FontAwesomeIcon icon={faRectangleVerticalHistory} />
                    </IconButton>
                ]
            );
        }

        if (enrollment && enrollment.masterEnrollmentId && enrollment.masterEnrollmentTrainingName) {
            headerItems.push(
                [
                    <Stack key="titleView" direction="column" justifyContent="center" alignItems="flex-end">
                        <Typography variant="overline">{t("shared:SysObjects.LearningPath")}</Typography>
                        <MprcClickable
                            onClick={() => navigate(LmsPaths.BuildEnrollmentViewer(TrainingType.LearningPath, enrollment.masterEnrollmentId!))}
                        >
                            <Typography
                                variant="caption"
                                color="primary.light"
                            >
                                {enrollment.masterEnrollmentTrainingName!}
                            </Typography>
                        </MprcClickable>
                    </Stack >
                ]
            );
        }

        return headerItems;

    }, [width, enrollment]);

    ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

    return (
            <MprcContainer position="sticky" margin="none" id={ENROLLMENT_VIEW_BAR_ID}>
                <MprcFormBarHeader actions={headerActions} />
                {loading && <Box mt={2}><MprcInfiniteLoading visible/></Box>}
            </MprcContainer>
    );
};
